import type { LicenceCountriesResponse, ProfileCategoryCountsResponse } from '@shared/schemas';

import api from '@/shared/api/api-client';

import { profileQueryHttp } from '../../_shared/infrastructure/profile-query.http';
import type { AiSearchResult, MyProfilesGateway } from './my-profiles.gateway';

/**
 * Client HNWIs list → the shared licence-scoped paginated read, plus the one call
 * that is this page's own: the category band's figures (#553).
 */
export const httpMyProfilesGateway: MyProfilesGateway = {
  ...profileQueryHttp,
  fetchCategoryCounts: () =>
    api.get<ProfileCategoryCountsResponse>('/profiles/category-counts'),
  interpretSearch: (query) => api.post<AiSearchResult>('/profiles/nl-search', { query }),
  fetchCountries: async () =>
    (await api.get<LicenceCountriesResponse>('/profiles/countries')).countries,
  fetchTagSuggestions: async () =>
    (await api.get<{ tags: string[] }>('/profiles/tags/suggestions')).tags,
};
